import { LocationVN } from './_vnLocation';

export interface Locations {
  Vietnam: {
    [cityName: string]: {
      districts: {
        [districtName: string]: string[];
      };
    };
  };
}

export const locations: Locations = {
  Vietnam: LocationVN.reduce(
    (acc, city) => {
      acc[city.name] = {
        districts: city.districts.reduce(
          (districtAcc, district) => {
            districtAcc[district.name] = district.wards.map(
              (ward) => `${ward.prefix} ${ward.name}`
            );
            return districtAcc;
          },
          {} as { [districtName: string]: string[] }
        ),
      };
      return acc;
    },
    {} as { [cityName: string]: { districts: { [districtName: string]: string[] } } }
  ),
};
